import { GoogleFontLoader } from 'components/GoogleFontLoader/GoogleFontLoader'
import Styles from './FontPairingSwatch.module.scss'
import { FontPairingSwatchProps } from './Types'
import { BlazeFontLoader } from 'components/BlazeFontLoader/BlazeFontLoader'

const FontPairingSwatch = ({ pairing }: FontPairingSwatchProps) => {
  const [title, body] = pairing

  if (!title || !body) {
    return (
      <div className={Styles.loadingState}>
        <div className={Styles.skeleton} style={{ height: 17, width: 109 }} />
        <div className={Styles.skeleton} style={{ height: 11, width: 71 }} />
      </div>
    )
  }

  return (
    <div className={Styles.swatch}>
      <div
        style={{
          fontSize: 20,
          fontFamily: title.style.font_family,
          fontWeight: title.style.font_weight,
          fontStyle: title.style.italic ? 'italic' : 'normal',
        }}
      >
        Headline
      </div>

      <div
        style={{
          fontSize: 14,
          fontFamily: body.style.font_family,
          fontWeight: body.style.font_weight,
          fontStyle: body.style.italic ? 'italic' : 'normal',
        }}
      >
        Body Text
      </div>
      <GoogleFontLoader family={title.style.font_family} />
      <BlazeFontLoader name={body.style.font_family} />
    </div>
  )
}

export { FontPairingSwatch }
